<template>
  <section class="min-w1600">
    <div class="main-contents-wrapper">
      <div class="tab-wrap">
        <template v-for="item in gameGroupCodes" :key="item.groupCode">
          <template v-if="item.groupCode !== 'sport'">
            <button type="button" class="tab-item" :class="{'active': item.groupCode === reqData.gameCategory}" @click="reqData.gameCategory = item.groupCode">{{ item.groupCodeName }}</button>
          </template>
        </template>
      </div>
      <div class="table-wrapper">
        <table class="mainTable">
          <thead>
             <tr>
                <th>{{ $t('table.head.userlv') }}</th>
                <th>{{ $t('table.head.minBetting') }}</th>
                <th>{{ $t('table.head.maxBetting') }}</th>
             </tr>
          </thead>
          <tbody>
            <tr v-for="item in userLevelList" :key="item.memLevelName">
              <td>{{ item.memLevel }}</td>
              <td>
                <div class="status-change-btn-wrap gap-5">
                  <input
                    type="text"
                    :value="formatNumber(getMinValue(item))"
                    @input="onInput($event, item, getMinField())"
                  >
                  <button
                    class="btn-innerTable btn-status-change wait"
                    type="button"
                    @click="saveBetLimit(item)"
                  >
                    {{ $t('button.save') }}
                  </button>
                </div>
              </td>
              <td>
                <div class="status-change-btn-wrap gap-5">
                  <input
                    type="text"
                    :value="formatNumber(getMaxValue(item))"
                    @input="onInput($event, item, getMaxField())"
                  >
                  <button
                    class="btn-innerTable btn-status-change wait"
                    type="button"
                    @click="saveBetLimit(item)"
                  >
                    {{ $t('button.save') }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
// import lodash from 'lodash'
import { getSiteData } from '@/libs/auth-helper'
import {
  settingLvBetLimit,
  settingLvBetLimitSave
} from '@/api/setting'
import { thousand } from '@/libs/utils'
import { mapState } from 'vuex'

export default {
  name: 'BetScaleSetting',
  components: {
  },
  data () {
    return {
      tableName: this.$route.name,
      headInfo: {
        fstColumn: false,
        dataList: ['userlv', 'bankCode', 'option']
      },
      siteInfo: {},
      userLevelList: [],
      reqData: {
        gameCategory: 'casino'
      },
      tabList: {}
    }
  },
  computed: {
    ...mapState([
      'gameGroupCodes',
      'siteData'
    ])
  },
  watch: {
  },
  methods: {
    async setTabList () {
      const group = this.reqData.gameCategory
      // console.log('group? : ', group)
      const gameList = await this.$store.getters.gameList
      // console.log('gameList? : ', gameList)
      if (group && gameList.length) {
        const gameObj = gameList.find(obj => {
          return obj.code === group
        })
        this.tabList = gameObj.child
      }
    },
    thousand,
    formatNumber (value) {
      if (!value) return ''
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    onInput (event, item, key) {
      // 입력값에서 콤마 제거
      const rawValue = event.target.value.replace(/,/g, '')
      // 숫자만 허용
      if (!/^-?\d*$/.test(rawValue)) return
      // item의 key 값 업데이트
      item[key] = rawValue
      // 다시 콤마 찍어서 input에 표시
      event.target.value = rawValue.startsWith('-') ? rawValue : this.formatNumber(rawValue)
    },
    getBetLimitList () {
      return settingLvBetLimit().then(res => {
        const data = res.data
        if (res.resultCode === '0') {
          console.log('레벨에 따른 베팅금액 : ', res)
          const list = data.list.map(item => ({
            ...item,
            _original: { ...item }
          }))
          this.userLevelList = list
        }
      })
    },
    getMinField () {
      return this.reqData.gameCategory === 'slot' ? 'betAmtMinSlot' : 'betAmtMin'
    },
    getMaxField () {
      return this.reqData.gameCategory === 'slot' ? 'betAmtMaxSlot' : 'betAmtMax'
    },
    getMinValue (item) {
      return item[this.getMinField()]
    },
    getMaxValue (item) {
      return item[this.getMaxField()]
    },
    saveBetLimit (item) {
      const minField = this.getMinField()
      const maxField = this.getMaxField()
      const min = item[minField]
      const max = item[maxField]

      // 원래 값 저장
      const originalMin = item._original?.[minField] || min
      const originalMax = item._original?.[maxField] || max

      if (Number(min) < 0) {
        alert('최소 베팅금은 0원부터 입니다.')
        this.restoreValues(item, minField, maxField, originalMin, originalMax)
        return
      }

      if (Number(max) > 100000000) {
        alert('최대 베팅금은 1억원까지 입니다.')
        this.restoreValues(item, minField, maxField, originalMin, originalMax)
        return
      }

      const params = {
        memLevel: item.memLevel,
        [minField]: String(min),
        [maxField]: String(max)
      }
      // console.log(params)

      return settingLvBetLimitSave(params).then(res => {
        if (res.resultCode === '0') {
          // console.log('베팅금액 저장 : ', res)
          alert('베팅금 수정 완료 되었습니다.')
          this.updateOriginalValues(item, minField, maxField, min, max)
        }
      })
    },
    restoreValues (item, minField, maxField, originalMin, originalMax) {
      item[minField] = originalMin
      item[maxField] = originalMax
    },
    updateOriginalValues (item, minField, maxField, min, max) {
      if (!item._original) item._original = {}
      item._original[minField] = min
      item._original[maxField] = max
    },
    getSiteInfo () {
      const siteInfoCookie = getSiteData()
      if (siteInfoCookie) {
        const siteInfo = JSON.parse(siteInfoCookie)
        return siteInfo
      }
    }
  },
  async created () {
    this.siteInfo = this.getSiteInfo()
    await this.setTabList()
    this.getBetLimitList()
  }
}
</script>

<style scoped>
.red {color: #f50000;}
.box-tip {font-weight: bold;gap: 5px;}
.box-tip .box {background: #c2e2ff;border: 1px solid #88c7ff;padding: 2px 3px;}
.bottom-btn-wrap {display: flex;justify-content: space-between;align-items: center;}
.bottom-btn-wrap > div {display: flex;align-items: center;gap: 5px;}
.w50 {width: 50px;}
.w140 {width: 140px;}
input {border-radius: 2px;border: solid 1px #000;background-color: #fff;color: #3d3d3d;font-weight: 800;}
td:nth-child(5) {/*text-align: left;*/}
th:nth-child(5) span, td:nth-child(5) span {white-space: pre-wrap;}
td:nth-child(5) textarea {width: 100%;height: 50px;}
.item-wrap > div.item-content{
  flex-direction: column;
  align-items: flex-start;
}
.info { padding: 20px;}
.info h3 {font-size: 20px;margin-bottom: 20px;}
.info ul {margin-bottom: 20px; font-size: 15px; line-height: 1.7;}
.info ul:last-child {margin-bottom: 0px;}
.info em {margin-right: 5px; font-weight: bold;}
.sub-title {
   color: #646464;
   font-size: 13px;
   padding-bottom: 11px;
   border-bottom: 2px solid #959595;
   display: flex;
   align-items: center;
   justify-content: space-between;
}
textarea {
  width: 100%;
  min-height: 160px;
  border: 1px solid #353535;
  resize: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 2px;
  background-color: #111827;
}
.center {text-align: center;margin: 50px 0 70px;}
.center button {
    font-size: 18px;
    width: 168px;
    height: 42px;
    cursor: pointer;
}
.pt50 {
  padding-top: 50px;
}
.modal-wrapper {
  display: flex;
  font-size: 16px;
}
</style>
